import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Apply dark mode from localStorage before render to prevent flash
if (localStorage.getItem('app_dark_mode') === 'true') {
  document.documentElement.classList.add('dark');
}

createRoot(document.getElementById("root")!).render(<App />);

// Register service worker for PWA installability (production only)
if ('serviceWorker' in navigator) {
  const isInIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();
  const isPreview = window.location.hostname.includes('id-preview--') ||
    window.location.hostname.includes('lovableproject.com');

  if (!isInIframe && !isPreview) {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  } else {
    // Unregister SW in preview/iframe to avoid stale cache
    navigator.serviceWorker.getRegistrations().then(r => r.forEach(reg => reg.unregister()));
    if ('caches' in window) caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
  }
}
